<template>	
	<el-tabs v-if="tabs" v-model="tab" type="card" class="main-tab" closable @tab-remove="onCloseTabClick">
		<el-tab-pane v-for="item in tabs"
			:key="item.id" 
			:label="item.name" 
			:name="item.id"
			@tab-click="onCloseTabClick">
			<application-tab-item-component :view="item.view" :params="item.params" />
		</el-tab-pane>
	</el-tabs>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { WatchStopHandle, watch } from 'vue';
import store from '@/store';
import ApplicationTabModel from '@/models/ApplicationTab';
import ApplicationTabItemComponent from '@/components/ApplicationTabItemComponent.vue';

@Options({
	components: {
		ApplicationTabItemComponent
	},
	props: {
		view: String,
		params: Array
	}
})
export default class ApplicationTabComponent extends Vue {

	tab: number | null = store.getters.tab;
	tabs: Array<ApplicationTabModel> = store.getters.tabs;

	storeSubscribeHandler: Function | null = null;
	watchActiveTabHandler: WatchStopHandle | null = null;

	mounted() {
		this.storeSubscribeHandler = store.subscribe((mutation) => {
			if (mutation.type == 'changeTab' ||
				mutation.type == 'addTab' ||
				mutation.type == 'removeTab') {
				this.tab = store.getters.tab;
				this.tabs = store.getters.tabs;
			}
		});

		this.watchActiveTabHandler = watch(
			() => this.tab,
			(newValue: number | null) => store.commit('changeTab', newValue)
		);
	}

	unmounted() {
		if (this.watchActiveTabHandler) {
			this.watchActiveTabHandler();
		}

		if (this.storeSubscribeHandler) {
			this.storeSubscribeHandler();
		}
	}

	onCloseTabClick(tabId: number) {		
		store.commit('removeTab', tabId);
	}
}
</script>

<style>
.el-main {
	padding: 0;
}

.main-tab {
	margin: 0;
}

.main-tab .el-tabs__nav-wrap {
	margin: 0;
}

.main-tab .el-tabs__nav {
	border: 0 !important;
	border-bottom: none !important;
	border-radius: 0 !important;
}

.main-tab .el-tabs__nav .el-tabs__item {
	border-left: 0;
}

.el-tabs__nav .el-tabs__item.is-active {
	border-top: 0
}

.main-tab .el-tabs__nav .el-tabs__item.is-active {
	border-top: 2px solid var(--el-color-primary);
}
</style>